export default {
  "necessary": [
  {
    "title": "ADS_VISITOR_ID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_3_months"
  },
    {
      "title": "VISITOR_PRIVACY_METADATA",
      "desc": "BED_22412_description_youtube_video_analitycal_data",
      "time": "BED_22412_duration_6_months"
    },
    {
      "title": "VISITOR_INFO1_LIVE",
      "desc": "BED_22412_description_youtube_video_analitycal_data",
      "time": "BED_22412_duration_6_months"
    },
    {
      "title": "YSC",
      "desc": "BED_22412_description_youtube_video_analitycal_data",
      "time": "BED_22412_duration_session"
    },
  {
    "title": "AEC",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_3_months"
  },
  {
    "title": "APISID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_month_4_days"
  },
  {
    "title": "APISID",
    "desc": "BED_22412_description_youtube_video_analitycal_data",
    "time": "BED_22412_duration_1_year_month_4_days"
  },
  {
    "title": "HSID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_month_4_days"
  },
  {
    "title": "IDE",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_9_months"
  },
  {
    "title": "NID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_6_months"
  },
  {
    "title": "S",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_session"
  },
  {
    "title": "SAPISID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_month_4_days"
  },
  {
    "title": "SID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_month_4_days"
  },
  {
    "title": "SIDCC",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "SSID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_month_4_days"
  },
  {
    "title": "WPabs",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "YmVkLWJvb2tpbmcuY29t-_lr_uf_-n7ybiv",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_session"
  },
    {
      "title": "mp_mixpanel",
      "desc": "BED_22412_description_mixpanel_user_experience",
      "time": "BED_22412_duration_1_year"
    },
  {
    "title": "__Secure-ENID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_9_months"
  },
  {
    "title": "_fbp",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_3_months"
  },
  {
    "title": "_firmlet_session_v2",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_month"
  },
  {
    "title": "_ga_*",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_month_4_days"
  },
  {
    "title": "_ga_*",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_month_4_days"
  },
  {
    "title": "_ga",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_5_months"
  },
  {
    "title": "_gat",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "_gcl_au",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_2_months"
  },
  {
    "title": "_gid",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "_hjSession_*",
    "desc": "BED_22412_description_mixpanel_user_experience",
    "time": "BED_22412_duration_10_months"
  },
  {
    "title": "ajs_anonymous_id",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_11_months"
  },
  {
    "title": "ajs_group_id",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_11_months"
  },
  {
    "title": "ajs_user_id",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_11_months"
  },
  {
    "title": "ar_debug",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_month"
  },
  {
    "title": "at_check",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_session"
  },
  {
    "title": "fs_uid",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "intercom-device-id-agpb1wfw",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_9_months"
  },
  {
    "title": "intercom-session-agpb1wfw",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "io",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_session"
  },
  {
    "title": "mbox",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_month_4_days"
  },
  {
    "title": "rl_anonymous_id",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "rl_group_id",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "rl_group_trait",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "rl_page_init_referrer",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_8_months"
  },
  {
    "title": "rl_page_init_referring_domain",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_8_months"
  },
  {
    "title": "rl_session",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "rl_trait",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "rl_user_id",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "YmVkLWJvb2tpbmcuY29t-_lr_uf_-n7ybiv",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_session"
  },
  {
    "title": "_fbp",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_3_months"
  },
  {
    "title": "_firmlet_session_v2",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_month"
  },
  {
    "title": "_ga",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_month_4_days"
  },
  {
    "title": "_gcl_au",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_2_months"
  },
  {
    "title": "_gid",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "ajs_anonymous_id",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_11_months"
  },
  {
    "title": "ajs_group_id",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_11_months"
  },
  {
    "title": "ajs_user_id",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_11_months"
  },
  {
    "title": "ADS_VISITOR_ID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_3_months"
  },
  {
    "title": "AEC",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_3_months"
  },
  {
    "title": "AEC",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_3_months"
  },
  {
    "title": "APISID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "APISID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "DSID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_week"
  },
  {
    "title": "HSID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "HSID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "IDE",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_8_months"
  },
  {
    "title": "NID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_3_months"
  },
  {
    "title": "NID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_6_months"
  },
  {
    "title": "OTZ",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "PHPSESSID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_session"
  },
  {
    "title": "S",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_session"
  },
  {
    "title": "SAPISID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "SAPISID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "SID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "SID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "SIDCC",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "SSID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "SSID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
    {
      "title": "SAPISID",
      "desc": "BED_22412_description_youtube_video_analitycal_data",
      "time": "BED_22412_duration_1_year_month_4_days"
    },  {
      "title": "SID",
      "desc": "BED_22412_description_youtube_video_analitycal_data",
      "time": "BED_22412_duration_1_year_month_4_days"
    },
    {
      "title": "SIDCC",
      "desc": "BED_22412_description_youtube_video_analitycal_data",
      "time": "BED_22412_duration_1_year"
    },
    {
      "title": "SOCS",
      "desc": "BED_22412_description_youtube_video_analitycal_data",
      "time": "BED_22412_duration_9_months"
    },
    {
      "title": "SSID",
      "desc": "BED_22412_description_youtube_video_analitycal_data",
      "time": "BED_22412_duration_1_year_month_4_days"
    },
  {
    "title": "WPabs",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "YmVkLWJvb2tpbmcuY29t-_lr_uf_-n7ybiv",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_session"
  },
  {
    "title": "__Secure-ENID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_8_months"
  },
  {
    "title": "__Secure-ENID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_8_months"
  },
  {
    "title": "__adroll",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_6_months"
  },
  {
    "title": "__adroll_shared",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_6_months"
  },
  {
    "title": "__mp_opt_in_out_cookies_metrics-1",
    "desc": "BED_22412_description_mixpanel_user_experience",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "__mp_opt_in_out_tracking_metrics-1",
    "desc": "BED_22412_description_mixpanel_user_experience",
    "time": "BED_22412_duration_1_year"
  },
    {
      "title": "__Secure-1PAPISID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_month_4_days"
    },
    {
      "title": "__Secure-1PAPISID",
      "desc": "BED_22412_description_youtube_video_analitycal_data",
      "time": "BED_22412_duration_1_year_month_4_days"
    },
    {
      "title": "__Secure-1PSID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_month_4_days"
    },
    {
      "title": "__Secure-1PSID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_month_4_days"
    },
    {
      "title": "__Secure-1PSIDCC",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year"
    },
    {
      "title": "__Secure-1PSIDCC",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year"
    },
    {
      "title": "__Secure-1PSIDTS",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year"
    },
    {
      "title": "__Secure-1PSIDTS",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year"
    },
    {
      "title": "__Secure-3PAPISID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_month_4_days"
    },
    {
      "title": "__Secure-3PAPISID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_month_4_days"
    },
    {
      "title": "__Secure-3PSID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_month_4_days"
    },
    {
      "title": "__Secure-3PSID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_month_4_days"
    },
    {
      "title": "__Secure-3PSIDCC",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year"
    },
    {
      "title": "__Secure-3PSIDCC",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year"
    },
    {
      "title": "__Secure-3PSIDTS",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year"
    },
    {
      "title": "__Secure-3PSIDTS",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year"
    },
    {
      "title": "__Secure-1PAPISID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_1_month"
    },
    {
      "title": "__Secure-1PAPISID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_1_month"
    },
    {
      "title": "__Secure-1PSID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_1_month"
    },
    {
      "title": "__Secure-1PSID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_1_month"
    },
    {
      "title": "__Secure-1PSIDCC",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year"
    },
    {
      "title": "__Secure-1PSIDTS",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year"
    },
    {
      "title": "__Secure-3PAPISID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_1_month"
    },
    {
      "title": "__Secure-3PAPISID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_1_month"
    },
    {
      "title": "__Secure-3PSID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_1_month"
    },
    {
      "title": "__Secure-3PSID",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_1_month"
    },
    {
      "title": "__Secure-3PSIDCC",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_1_month"
    },
    {
      "title": "__Secure-3PSIDTS",
      "desc": "BED_22412_description_profile_retargeting",
      "time": "BED_22412_duration_1_year_1_month"
    },
  {
    "title": "__utma",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "__utmc",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_session"
  },
  {
    "title": "__utmz",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_6_months"
  },
  {
    "title": "_dc_gtm_UA-37955877-1",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "_fbp",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "3 miesiąc"
  },
  {
    "title": "_firmlet_session_v2",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_month"
  },
  {
    "title": "_ga",
    "desc": "BED_22412_description_mixpanel_user_experience",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "_ga",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "_ga",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "_gcl_au",
    "desc": "BED_22412_description_mixpanel_user_experience",
    "time": "BED_22412_duration_3_months"
  },
  {
    "title": "_gcl_au",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_2_months"
  },
  {
    "title": "_gid",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "_gid",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "_gid",
    "desc": "BED_22412_description_mixpanel_user_experience",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "_login_cookie",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "_smvs",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "_twitter_sess",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_session"
  },
  {
    "title": "ajs_anonymous_id",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "ajs_group_id",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "ajs_user_id",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "ar_debug",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_month"
  },
  {
    "title": "c_user",
    "desc": "BED_22412_description_tool_user_movement",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "d_prefs",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_4_months"
  },
  {
    "title": "datr",
    "desc": "BED_22412_description_tool_user_movement",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "mp__origin",
    "desc": "BED_22412_description_mixpanel_user_experience",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "mp__origin_referrer",
    "desc": "BED_22412_description_mixpanel_user_experience",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "mp_account_id",
    "desc": "BED_22412_description_mixpanel_user_experience",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "mp_distinct_id",
    "desc": "BED_22412_description_mixpanel_user_experience",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "sessionid",
    "desc": "BED_22412_description_mixpanel_user_experience",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "smvr",
    "desc": "BED_22412_description_tool_anonymous_visit",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "_stripe_mid",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "_stripe_sid",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_33985_30_minutes"
  },
  {
    "title": "_ga",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "_ga_TPP1FRFRHT",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "_glc_au",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_3_months"
  },
  {
    "title": "chatbase_anon_id",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_session"
  },
  {
    "title": "ph_phc_*",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "sb-backend-auth-token.0",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "sb-backend-auth-token.1",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "sidebar-width",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "tracking-preferences",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_year"
  }
],
  "functional": [
  {
    "title": "CONSENT",
    "desc": "BED_22412_description_youtube_video_analitycal_data",
    "time": "BED_22412_duration_9_months"
  },
  {
    "title": "DSID",
    "desc": "BED_22412_description_tool_data_collection",
    "time": "BED_22412_duration_1_day"
  },
  {
    "title": "HSID",
    "desc": "BED_22412_description_youtube_video_analitycal_data",
    "time": "BED_22412_duration_1_year_month_4_days"
  },
  {
    "title": "_ga",
    "desc": "BED_22412_description_tool_social_media_posts",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "guest_id",
    "desc": "BED_22412_description_tool_social_media_posts",
    "time": "BED_22412_duration_6_months"
  },
  {
    "title": "guest_id_ads",
    "desc": "BED_22412_description_tool_social_media_posts",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "guest_id_marketing",
    "desc": "BED_22412_description_tool_social_media_posts",
    "time": "BED_22412_duration_1_year"
  },
  {
    "title": "muc",
    "desc": "BED_22412_description_tool_social_media_posts",
    "time": "BED_22412_duration_8_months"
  },
  {
    "title": "muc_ads",
    "desc": "BED_22412_description_tool_social_media_posts",
    "time": "BED_22412_duration_8_months"
  },
  {
    "title": "personalization_id",
    "desc": "BED_22412_description_tool_social_media_posts",
    "time": "BED_22412_duration_8_months"
  },
  {
    "title": "smuuid",
    "desc": "BED_22412_description_tool_anonymous_visit",
    "time": "BED_22412_duration_1_year_1_month"
  }
],
  "analytics": [
  {
    "title": "LOGIN_INFO",
    "desc": "BED_22412_description_youtube_video_analitycal_data",
    "time": "BED_22412_duration_10_months"
  },
  {
    "title": "PREF",
    "desc": "BED_22412_description_youtube_video_analitycal_data",
    "time": "BED_22412_duration_1_year_month_4_days"
  },

  {
    "title": "fr",
    "desc": "BED_22412_description_tool_user_movement",
    "time": "BED_22412_duration_4_months"
  },
  {
    "title": "m_ls",
    "desc": "BED_22412_description_tool_user_movement",
    "time": "BED_22412_duration_6_months"
  },
  {
    "title": "m_pixel_ratio",
    "desc": "BED_22412_description_tool_user_movement",
    "time": "BED_22412_duration_session"
  },
  {
    "title": "new-version-modal",
    "desc": "BED_22412_description_tool_user_movement",
    "time": "BED_22412_duration_8_months"
  },
  {
    "title": "oo",
    "desc": "BED_22412_description_tool_user_movement",
    "time": "BED_22412_duration_1_year_1_month"
  },
  {
    "title": "presence",
    "desc": "BED_22412_description_tool_user_movement",
    "time": "BED_22412_duration_session"
  },
  {
    "title": "sb",
    "desc": "BED_22412_description_tool_user_movement",
    "time": "BED_22412_duration_1_year"
  }
],
  "performance": [],
  "advertisement": [
  {
    "title": "usida",
    "desc": "BED_22412_description_tool_user_movement",
    "time": "BED_22412_duration_session"
  },
  {
    "title": "wd",
    "desc": "BED_22412_description_tool_user_movement",
    "time": "BED_22412_duration_1_week"
  },
  {
    "title": "x-referer",
    "desc": "BED_22412_description_tool_user_movement",
    "time": "BED_22412_duration_session"
  },
  {
    "title": "xs",
    "desc": "BED_22412_description_tool_user_movement",
    "time": "BED_22412_duration_1_day"
  }
]
}
